exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq-section[data-v-148d29a4]{background-color:#f2f3f7;padding:4rem 2rem;height:auto;margin:2rem auto 0;width:100%;max-width:800px}@media (max-width:575px){.faq-section[data-v-148d29a4]{padding:2rem 1rem}}", ""]);

// exports
